<template>
  <div class="min-h-screen bg-gray-50 flex items-center justify-center p-6">
    <div class="w-full max-w-md">
      <!-- Logo -->
      <div class="text-center mb-8">
        <a href="/" class="inline-flex items-center gap-2.5">
          <div
            class="w-10 h-10 bg-blue-600 rounded-xl flex items-center justify-center"
          >
            <span class="text-white font-bold text-lg">R</span>
          </div>
          <span class="text-lg font-bold text-blue-800"
            >Fluxreload - Admin</span
          >
        </a>
      </div>

      <div class="bg-white rounded-2xl shadow-xl p-8">
        <h1 class="text-2xl font-bold text-gray-900 mb-2">Admin Login</h1>
        <p class="text-gray-500 mb-6">
          Connectez-vous pour accéder au panneau d'administration
        </p>

        <form @submit.prevent="handleLogin" class="space-y-5">
          <!-- Password -->
          <div>
            <label class="block text-sm font-medium text-gray-700 mb-2"
              >Mot de passe administrateur</label
            >
            <div
              class="border border-gray-300 rounded-xl overflow-hidden focus-within:ring-2 focus-within:ring-blue-600 focus-within:border-blue-600 transition-all"
            >
              <input
                v-model="password"
                type="password"
                required
                class="w-full px-4 py-3 outline-none transition-all"
                placeholder="Entrez votre mot de passe"
              />
            </div>
          </div>

          <!-- Error message -->
          <div
            v-if="error"
            class="bg-red-50 border border-red-200 text-red-700 px-4 py-3 rounded-xl text-sm"
          >
            {{ error }}
          </div>

          <!-- Submit button -->
          <button
            type="submit"
            :disabled="loading"
            class="w-full py-3.5 bg-blue-600 text-white font-semibold rounded-xl shadow-md hover:shadow-lg hover:bg-blue-700 transition-all duration-200 disabled:opacity-50 disabled:cursor-not-allowed"
          >
            <span v-if="loading">Connexion...</span>
            <span v-else>Se connecter</span>
          </button>
        </form>

        <!-- Back to home -->
        <div class="text-center mt-6">
          <a
            href="/"
            class="inline-flex items-center gap-2 text-gray-600 hover:text-blue-600 transition-colors text-sm"
          >
            <svg
              class="w-4 h-4"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M10 19l-7-7m0 0l7-7m-7 7h18"
              />
            </svg>
            Retour à l'accueil
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue';
import { useRouter } from 'vue-router';
import { getCurrentInstance } from 'vue';

const router = useRouter();
const { proxy } = getCurrentInstance();
const { $constants } = proxy;

const password = ref('');
const loading = ref(false);
const error = ref('');

const handleLogin = async () => {
  loading.value = true;
  error.value = '';

  try {
    const response = await fetch(`${$constants.ENDPOINTS.LOCAL_API}/admin/login`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ password: password.value })
    });

    const data = await response.json();

    if (response.ok) {
      // Store token in localStorage
      localStorage.setItem('adminToken', data.token);
      // Redirect to dashboard
      router.push('/admin/dashboard');
    } else {
      error.value = data.message || 'Mot de passe incorrect';
    }
  } catch (err) {
    error.value =
      'Erreur de connexion au serveur. Vérifiez que le serveur API est démarré.';
    console.error('Login error:', err);
  } finally {
    loading.value = false;
  }
};
</script>
